import React from 'react';

function OfferDetailsBadge() {
  return (
    <div className='ppq--web--offer-card--body--offer--special--details'>
      <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.2 5.9999C11.2 9.0799 8.68 11.5999 5.6 11.5999C2.52 11.5999 0 9.0799 0 5.9999C0 2.9199 2.52 0.399902 5.6 0.399902C8.68 0.399902 11.2 2.9199 11.2 5.9999ZM6.2 3.3999C6.2 3.7199 5.92 3.9999 5.6 3.9999C5.28 3.9999 5 3.7199 5 3.3999C5 3.0799 5.28 2.7999 5.6 2.7999C5.92 2.7999 6.2 3.0799 6.2 3.3999ZM6.8 7.9999H6V4.7999H4.4V5.5999H5.2V7.9999H4.4V8.7999H6.8V7.9999ZM5.6 1.1999C8.24 1.1999 10.4 3.3599 10.4 5.9999C10.4 8.6399 8.24 10.7999 5.6 10.7999C2.96 10.7999 0.8 8.6399 0.8 5.9999C0.8 3.3599 2.96 1.1999 5.6 1.1999Z'
          fill='#066FEF'
        />
      </svg>
      <span className='ppq--web--offer-card--body--offer--special--details--label'>Offer Details</span>
    </div>
  );
}

export default OfferDetailsBadge;
